export default "__VITE_ASSET__BuSWh5TU__"